import script from "./CustomerReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerReview.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerReview.vue?vue&type=style&index=0&id=7eec47d2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eec47d2"]])

export default __exports__